import { css } from 'styled-components';
import PropTypes from 'prop-types';

export const BASIC_PROP_NAMES = [
	'margin',
	'ml',
	'mr',
	'mt',
	'mb',
	'padding',
	'flex',
	'isAuto',
	'justifyContent',
	'alignItems',
	'width',
	'maxWidth',
	'minWidth',
	'maxHeight',
	'minHeight',
	'height',
	'flexDirection',
	'color',
	'fontSize',
	'fontWeight',
	'overflow',
	'gap',
	'cursor',
	'position',
	'alignSelf',
	'flexWrap',
];

const BASIC_PROP_SET = new Set(BASIC_PROP_NAMES);

export const shouldForwardBasicProp = (prop, defaultValidatorFn) => {
	if (typeof defaultValidatorFn === 'function' && !defaultValidatorFn(prop)) {
		return false;
	}

	return !BASIC_PROP_SET.has(prop);
};

export const BasicProps = css`
    box-sizing: border-box;
    
    ${(props) => props.margin && css`
        margin: ${props.margin};
    `}
    ${(props) => props.ml && css`
        margin-left: ${props.ml}px;
    `}
    ${(props) => props.mr && css`
        margin-right: ${props.mr}px;
    `}
    ${(props) => props.mt && css`
        margin-top: ${props.mt}px;
    `}
    ${(props) => props.mb && css`
        margin-bottom: ${props.mb}px;
    `}

    ${(props) => props.padding && css`
        padding: ${props.padding};
    `}

    ${(props) => props.flex && css`
        flex: ${props.flex};
    `}

    ${(props) => props.isAuto && css`
        flex: 1 1 0;
    `}

    ${(props) => props.justifyContent && css`
        justify-content: ${props.justifyContent};
    `}

    ${(props) => props.alignItems && css`
        align-items: ${props.alignItems};
    `}

    ${(props) => props.width && css`
        width: ${Number(props.width) ? `${props.width}px` : props.width};
    `}

    ${(props) => props.maxWidth && css`
        max-width: ${Number(props.maxWidth) ? `${props.maxWidth}px` : props.maxWidth};
    `}

    ${(props) => props.minWidth && css`
        min-width: ${Number(props.minWidth) ? `${props.minWidth}px` : props.minWidth};
    `}
    
    ${(props) => props.maxHeight && css`
        max-height: ${Number(props.maxHeight) ? `${props.maxHeight}px` : props.maxHeight};
    `}

    ${(props) => props.minHeight && css`
        min-height: ${Number(props.minHeight) ? `${props.minHeight}px` : props.minHeight};
    `}

    ${(props) => props.height && css`
        height: ${Number(props.height) ? `${props.height}px` : props.height};
    `}

    ${(props) => props.flexDirection && css`
        flex-direction: ${props.flexDirection};
    `}

    ${(props) => props.color && css`
        color: ${props.color};
    `}

    ${(props) => props.fontSize && css`
        font-size: ${props.fontSize};
    `}

    ${(props) => props.fontWeight && css`
        font-weight: ${props.fontWeight};
    `}

    ${(props) => props.overflow && css`
        overflow: ${props.overflow};
    `}

    ${(props) => props.gap && css`
       gap: ${props.gap}px;
    `}

    ${(props) => props.cursor && css`
        cursor: ${props.cursor};
    `}

    ${(props) => props.position && css`
        position: ${props.position};
    `}

    ${(props) => props.alignSelf && css`
        align-self: ${props.alignSelf};
    `}

    ${(props) => props.flexWrap && css`
        flex-wrap: ${props.flexWrap};
    `}
`;

export const BasicPropTypes = {
	margin: PropTypes.string,
	ml: PropTypes.number,
	mr: PropTypes.number,
	mt: PropTypes.number,
	mb: PropTypes.number,
	padding: PropTypes.string,
	flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isAuto: PropTypes.bool,
	justifyContent: PropTypes.string,
	alignItems: PropTypes.string,
	flexDirection: PropTypes.string,
	color: PropTypes.string,
	fontSize: PropTypes.string,
	overflow: PropTypes.string,
	gap: PropTypes.number,
	position: PropTypes.string,
	cursor: PropTypes.string,
	alignSelf: PropTypes.string,
	flexWrap: PropTypes.string,
};
